import colors from '@constants/colors';
import {
    RefObject, useEffect, useMemo, useRef,
} from 'react';

import * as styles from '../../styles';

interface Props {
    markers?: MarkerProps[];
    mapRef: RefObject<inavi.maps.Map | null>;
    isMapLoad: boolean;
    onMarkerClick?: (id?: string, lat?: number, lng?: number) =>void;
}

const heartIcon = `<svg width="20" height="20" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M14 21.75C12.0017 21.315 5.84375 17.9075 5.84375 11.7812C5.84375 10.8302 6.14298 9.9033 6.69906 9.13178C7.25514 8.36027 8.03987 7.78327 8.94209 7.48253C9.84432 7.18179 10.8183 7.17254 11.7261 7.45611C12.6338 7.73968 13.4294 8.30168 14 9.0625C14.5706 8.30168 15.3662 7.73968 16.2739 7.45611C17.1817 7.17254 18.1557 7.18179 19.0579 7.48253C19.9601 7.78327 20.7449 8.36027 21.3009 9.13178C21.857 9.9033 22.1562 10.8302 22.1562 11.7812C22.1562 17.9075 15.9983 21.315 14 21.75Z"
                  fill="${colors.gray5}" stroke="white" stroke-width="1.93333"
                 fill-opacity="0.7"/>
</svg>`;

const clusterIcon74 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAYAAAAc0MJxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUaSURBVHgB7ZzPbxpXEMfnjQ1EajjlFE4+kUujRFClqS917+6pJ66IgCK7btVUvUa+tFKkVK3jxIESpJz4B3zKpb5UadJiLrmEP8D8AVApxfF7mVkvv7PLArtr2H0fyWZh10Lv65nZ2XlvngCfyWaz8csxTKKApJRwTQBcVgDXzNNXRy5vKgUtuqalBDRWEE6kgsbeQbkGPiPAB3bu5tIgIU2HafrGNLiBghquwBEKUfv18R8N8BjPhDIsJ4IZ+oINsoYkeAtZniqpiKrt71dOwANcF2o7m02IKGYQYJNcKg7+cyhXZcltwVwTyrCgKN6jw01YDFwVzBWhvi/kMuRe+QuyIEuMm4CC6l6xXII5mUsodjOM4H3XArR3NMm6CvNY1wrMCFuRWBU/k0hrsPjEUYrNL9Kpzt+14zcwAzMJ9V0+d08h5OkwBstDjMLD+ufpFLyqHU+dh03lehyw41G8T7FoA5YYGvRRqyN3K5VKa4q/cQaL9EkEi8L7nMgXKMg3/juVBadiOXK9oInE0FiuRFCsf3rj5ot6vd6ZdD2CA9jdgiRSFx4Tj83JtRMtaqeQy5ODfgPBZe12KhWnAP/S7iJbocxE8lsIOgKuU+rQsksdLF2Pk0nOtiEk8Fi3t7MJq/OWQmEUi4v2SOIlPFY8tY5XH3U9My5tQNgQkLBywTGLMsokAjIQUtgFOR0a/XxMKHK5hasC+AmP3SwXDTEkFFsTLE496SLZHA3sQ0KxNYHGQLzHofDTE0pb0zBcyh6MVT2hREQsevHNV4xYFetbVV8oIbTbjSBkP0UyhNrausMPvFdBMwRPsxlzkmAKFVFKu501faHkWQizcKecz3CD+Iki+7so/gkaS9od+RW+i2HgCnJuYywqwQBWLt2GNUIlIQEaW3h5EtJshLaoCfAaLqSSSmgrBU5RhuuFuKQyDZxH6Yx8EgoSjub1NA4nQDVaKMewUE3Q2CPgRFuUA6gu1UaF8BY0tpBGLWS1QGMLr6VC1BY1EW4tQe4tAY0trBFe+l9qoSbQJo3wAa9hVOB7t9LSIKDG6zzP0wPUQllBRbsj49V8r4WygNvcjFf+xY2CVJzSsWqcZrcXsJeZK9PENH24B7B73BOK7n5V7kYCTQ9ulOwe94R6cL6C/xA0XQ4Hu7GGHorPOrIKGgNuihx8PyTUfsVQUFvViDUxY2WWSx35MMyxisc+ak3M2PLpv+r1zq1bqY5QsA5hRMDzR0+eHY1/bMFOIVdcghZYt2nuPS1//bETlhVOeSp3w+SCpssVrM5bNg29rtdbYXJBqsvt7z1+ZtlhZdtd9fqf4ze3P0vxTPJ1CDICSr8flJ/bXTKxX+/Vv8cvSSxeyLEGAYT7iyku/TLpOkezMLEOxasAVkK5Fs5N2E6uddRTzCnDlzduvjhDsU7/gisQADxpvmZ6Yq2INVhyN2R3a5/KHz1p5x9k524uT+XjpVzArwCqj56WH8KUzLSTBgX4GqUOLVTG3XApdtPgPMlIAQ5m29Bm/k1soliERV9jRRMEckXuzrOJjSvbIrEr0l0xs4jbIgmE0m9PynOXj1zbaMu0Lo5bC7PRVpsqIdMEbDs82brtogQzntdIILUqqwu7ddsoRhN3RKTN9jZPYxi5fEPQ5AjN6FbdsqBRfNle8oetO0mpVJrm8DdoVO6UboQxF2n8+LEvpy9CDTK4YemZBN46IEk3grh5IxjbsJR/UUB+q3gxF73yggleC+CV5VjxATGDzpyvh1eeAAAAAElFTkSuQmCC';
const clusterIcon55 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAA3CAYAAACo29JGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPASURBVHgB3Zq/UxNREMf37V0IDqSywj8gVjYJMkJjbKj0D4h2mZjoyDCOlBZI6wyOg4hDhHQOvfoHYCUDJhTSmEoaU1kFCjG85+5LgheSyy+ScPc+zV1yd8l9Z/f2dt+ugD6TSCRCYwERAyHCCDChAK4LgHHahmrn0OeSVFDkrRJQoGM5sGVhdTX7C/qIgD7AgsYDGKfdKP1iFHpEKShYFnwqo/zSD6EXEjf/OBkFCamLCHKDbmybrLq18m4jBz3Sk7hnTx6Gy2W1MAhRDSjIyYBc6sWSXYlj9wvZmFIIcRg2CjIr6xuZbi7pWNxcInENR3Cddifg8ihKW6Y7taLVyUlzj5IxyxIrtHsVLpcQSnH35mTkcPdb/me7k9uKe5pOxsm+L2g3CN4gSO42Ox2NlHZy+YNWJ7YUx8KkgAXwIBRJZ9oJdBXHrli1mGdhgeSiBTcXbRpQOHhYI/jBmVV4Fc5yTm35oFmQwWYXcFT0gzCG7xPLuM6vqfPHGsTNp5MpuNxw3wsT/P49/2WdW1bfZR/Bp9iWuP/q7ftC7XOd5TCAi+BjdEro4EycToKHkSsOErp/raPKmTgKq8PPFwcBVylVtDh+1oSEGJgAWa8WObU4exRvg0GMB3XhXBGnJNwDk5CV2CH8Hv7dODqRd9AewTAYyNioiKECn4d/NyStvtGKk5GW42VFFMIfCXK30Hub1019lyR3hFBULfiltOkWXQqBwZgtjst0MBDWxc/cEZgIdZGQlsZ/gIGQrhKihCIYCLfDUCpVAAOhBdkcXvmrtsFAytSpxZfZbIl7YGAQlJ3oFnTlPYeGiaPWM2+1uNE/cgsMgnvqvNXiTHJN7qXX+gb/0y+ErlqyXoWHBGr7Z+L01IDfrScg55x+qEucbVssg4+Rllxyfq5rPn7dy/++NRnh+u4G+A0BmTdrm9vOrxpKnuCJ5GfPbylZkdyxIWY0iOPIKU9k2i+lkJ4js2W62bGmPfHd/f3S9GTkkMqhWfA4EuD56trm92bHXBv+O9REn5qKlCiVmQGPggjL5I6f3Y63HNXY3csfeFUgC3u9ttEys2o7ZMMCyUW5LJoGDwza6GeMXLGVxRzndoYfZ7+6HkmktmyKMpkUDBkKblvH9JrKch7cIT3NW2orBnGR/nHwTRRKqWwUy84phc4vvQDcXKdeQ1wNouUsdJ6bGfqk7HnYktx65g4tuU/vXaOKoNwR1ZfduJ/7z/UZLZQamqfU9yOrhrkhAZUp9brpdF4vFbSsKHn1jRapjmktpx+CnPwDpblWobhC1XUAAAAASUVORK5CYII=';
const clusterIcon40 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAK3SURBVHgBzZlPbtNAFMa/GVpSifgAzQHSVRckKCqsegA4QFiGKAaptEhwCgQsaKSSKFjsegB6BVQKON10Qw5QHyDtglTy8N40ttLUSRzLtecnRY49tvTpPc/7Z4GE7L5qVqVAWfmoKmBDAEU6WrxG/4e+gkfr50pgQJfczwc9FwkQy9zcaDSs4qqsC4F6IGYJPPq5/orfbbed87gPxRLIwqwV2VISdaTDUVyhCwW+sZt1clMrgcUW4Smluvudr9/n3XRv3uJeq/mWrNaivwWkjyWE2N6qVKwTt38866ZIC47ftQ+0WkUGKIXB5ZVvO44znF6TUQ88WJWdrMQxtOnK2iAR3HIxu5VkbyNrBEpR7r4h8LX94hmk2EFeCGw+rlaGP93+WXApdPFOo1Gil7aFnOGIwXsgOA8FyvuSxa0jZzicccwNzrVAth4dnsIQOCEEVtQCx9YzimJB6qwVuDizkBIXoa7TquCqhBzfgYkI2GxB46wXwOWcpG1dhqFwrSmljxIMhY3HLs499s2CNool76DOSw3WJmE4khscGAprYxdfwFS4M6S89xemQm2rpIIwUb+aBdxTS2qwBzAXV3LHb+hG8VibDjNkykOYh371tMC1f75xAnnywEct8D31o+Rmk0QeBWORMJMURn7XkHfRC6zHhG3nj9PTUa1WGVGCfoIcoXnNp/aBE4a+G33xr9/9s61HFS4eNpEDlNUOaZj0bfJa5Gxm125mOvpgeD6z3+k9n74eWc2sXfnvRJYBXMDl4VH00hz2XtL4DakNLSPRbv3S+zhrfe588ORP/7hWfejRSGQDKRe2upSSaFO26C64bzE8eRg396lMH9hqlxTWouaB0yw1RJ8QyhtoqV6GLcYp9YKyVhxhE88lQzf8JJSHj7juDNcnP0NwISyo1hQ82acNl/QzxH8SUup6Hrr9PwAAAABJRU5ErkJggg==';

function useMarkers({
    mapRef, markers, isMapLoad, onMarkerClick,
}:Props) {
    //  아이콘을 포함한 마커 생성
    const markerWithIcons = useMemo<(MarkerProps&{icon: HTMLElement})[]|undefined>(() => markers?.map((props) => {
        const icon = document.createElement('span');
        icon.className = styles.marker;
        // 이벤트에서 마커를 식별하기 위한 id 설정
        icon.id = `${props.id}`;
        icon.innerHTML = props.isMyShop ? `${heartIcon}${props.name}` : props.name;
        return { ...props, icon };
    }), [markers]);
    // 실제 표시될 마커
    const realMarkers = useMemo<inavi.maps.Marker[]>(() => {
        const map = mapRef.current;
        if (map && markerWithIcons && isMapLoad) {
            return markerWithIcons.map((props) => new inavi.maps.Marker({
                position: [props.lng, props.lat],
                icon: props.icon,
            }));
        }
        return [];
    }, [markerWithIcons, mapRef, isMapLoad]);
    const clusterRef = useRef<inavi.maps.MarkerClusterer>(null);

    const initialIzeCluster = () => {
        if (mapRef.current) {
            const markerStyle = [
                { url: clusterIcon74, size: [74, 74], position: [0, 0] },
                { url: clusterIcon74, size: [74, 74], position: [0, 0] },
                { url: clusterIcon74, size: [74, 74], position: [0, 0] },
                { url: clusterIcon55, size: [55, 55], position: [0, 0] },
                { url: clusterIcon40, size: [40, 40], position: [0, 0] },
            ];
            const cluster = new inavi.maps.MarkerClusterer(mapRef.current, realMarkers, {
                gridSIze: 10,
                maxZoom: 14,
                styles: {
                    icons: markerStyle,
                    textColor: 'white',
                    textSize: 19,
                },
            });
            // 마커 클릭 이벤트를 등록
            const handleMarkerClick = (e: any) => {
                console.log(e.target);
                if (e.target && !e.target?.cluster && 'getIcon' in e.target && 'getPosition' in e.target) {
                    const icon = e.target.getIcon() as HTMLSpanElement;
                    const position = e.target.getPosition() as LatLng;

                    onMarkerClick?.(icon.id, position.lat, position.lng);
                }
            };
            cluster.on('click', handleMarkerClick);
            cluster.on('touchstart', handleMarkerClick);
            clusterRef.current = cluster;
        }
    };
    const refreshMarkers = () => {
        console.log('refeshMarkers');
        const cluster = clusterRef.current!;
        const prevMarkers = cluster.getMarkers();

        // 새로 추가될 마커
        const willAddMarkers = realMarkers.filter((marker) => {
            const oldMarker = prevMarkers.find((prevMarker) => {
                const { lat, lng } = prevMarker.getPosition();
                const newPosition = marker.getPosition();
                return lat === newPosition.lat && lng === newPosition.lng;
            });
            return !oldMarker;
        });
        const bound = mapRef.current!.getBounds();
        // 제거될 마커
        const willRemoveMarkers = prevMarkers.filter((prevMarker) => {
            const { lat, lng } = prevMarker.getPosition();
            const notExist = !realMarkers.find((m) => {
                const existPosition = m.getPosition();
                return existPosition.lat === lat && existPosition.lng === lng;
            });
            return notExist || lat > bound.north || lat < bound.south || lng < bound.west || lng > bound.east;
        });
        cluster.addMarkers(willAddMarkers);
        willRemoveMarkers.forEach((marker) => {
            cluster.removeMarker(marker);
        });
    };

    // 클러스터링
    useEffect(() => {
        if (mapRef.current) {
            if (clusterRef.current) {
                refreshMarkers();
            } else {
                initialIzeCluster();
            }
        }

        return () => {};
    }, [realMarkers, onMarkerClick, markerWithIcons, mapRef]);

    return realMarkers;
}

export default useMarkers;
